"use client";

import { useCookieConsent } from "./CookieConsentProvider";

export default function CookieSettingsButton({
  children,
}: {
  children: React.ReactNode;
}) {
  const { openSettings } = useCookieConsent();

  return (
    <button
      type="button"
      className="text-ring md:hover:text-primary max-w-full cursor-pointer text-left break-words transition-all duration-200"
      onClick={openSettings}
    >
      {children}
    </button>
  );
}
